import { useState } from "react";

import { generateInvoiceAct, generateInvoiceDocument } from "services/serviceOrders/rest";
import { InvoiceServiceOrderDto } from "services/serviceOrders/restModels";
import { UseNotificationSnackbarReturn } from "shared/ui/NotificationSnackbar/useNotificationSnackbar";

export const useInvoiceDocuments = (
    notify: UseNotificationSnackbarReturn,
    onInvoiceUpdated: (invoice: InvoiceServiceOrderDto) => void
) => {
    const [busyInvoiceId, setBusyInvoiceId] = useState<string | null>(null);

    /*
    * Вкладка открывается до запроса: Safari на iOS пропускает window.open только прямо по нажатию,
    * а документ формируется не мгновенно.
    * */
    const openDocument = async (
        invoice: InvoiceServiceOrderDto,
        link: string | null,
        generate: (invoiceId: string) => Promise<InvoiceServiceOrderDto>,
        readLink: (updated: InvoiceServiceOrderDto) => string | null,
        failureTitle: string
    ) => {
        const documentWindow = window.open(link ?? "", "_blank");

        if (link && documentWindow) return;

        setBusyInvoiceId(invoice.invoiceId);

        try {
            if (!documentWindow) throw new Error("Браузер заблокировал новую вкладку");

            const updated = await generate(invoice.invoiceId);

            documentWindow.location.href = readLink(updated);
            onInvoiceUpdated(updated);
        } catch (caught) {
            if (documentWindow) documentWindow.close();

            notify.showError(failureTitle, caught);
        } finally {
            setBusyInvoiceId(null);
        }
    };

    return {
        busyInvoiceId,
        onOpenInvoice: (invoice: InvoiceServiceOrderDto) =>
            openDocument(
                invoice,
                invoice.invoiceLink,
                generateInvoiceDocument,
                ({ invoiceLink }) => invoiceLink,
                "Не удалось получить счёт"
            ),
        onOpenAct: (invoice: InvoiceServiceOrderDto) =>
            openDocument(
                invoice,
                invoice.actLink,
                generateInvoiceAct,
                ({ actLink }) => actLink,
                "Не удалось получить акт"
            ),
    };
};
